module.exports = __webpack_public_path__ + "cd2aaa6b40f7b28d29b72df5787827be.fbx";